import React, { useEffect, useState } from "react";
import data from "../../../../data/search.json";
import Select from 'react-select';
import ReactDOM from "react-dom";

const ContentLinkModal = ({ editor, modal, onClose }) => {
    const [selected, setSelected] = useState("");

    useEffect(() => {
        if (!editor) return;
        const attrs = editor.getAttributes("contentLink");
        if (attrs?.href) {
            setSelected(attrs.href);
        }
    }, [editor]);

    const options = data || [];

    const handleChange = (value) => {
        setSelected(value);
    };

    const handleSave = () => {
        if (!selected) return;
        editor
            .chain()
            .focus()
            .setContentLink({ href: selected })
            .run();
        onClose();
    };
    return (
          <div
        className={"modal-overlay modal fade " + (modal ? "show " : "")}
        id="exampleModal"
        tabIndex="-1"
        style={modal ? { display: "block" } : { display: "none" }}
      >
            <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Add Content Link</h3>
                </div>
                 <div className="modal-body" style={{height : 300}}>
                        <form className="row g-3 needs-validation" onSubmit={() => { }}>
                        <div className="col-md-12">
                            <label className="label-modern">Target Content Page</label>
                            <Select
                                options={data}
                                onChange={(option) => setSelected(option.value)}
                                // value={data.find(opt => opt.value === selected)}
                                 value={data.find(
                                        (opt) =>
                                        opt.value.replace(/^\/?[^/]+/, "") ===
                                        selected.replace(/^\/?[^/]+/, "")
                                    )}
                                maxMenuHeight={200}
                            />
                            {/* <Select
                            // closeMenuOnSelect={false}
                                options={data}
                                onChange={handleChange}
                                maxMenuHeight = {200}
                                value={selected}
                                className="input-modern"
                                styles={{width: "auto"}}
                            /> */}
                            {/* <select
                                className="input-modern"
                                value={selected}
                                onChange={(e) => setSelected(e.target.value)}
                            >
                                <option value="">-- Select a target --</option>
                                {options.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </select> */}
                        </div>
                        </form>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "1rem", marginTop: "2rem" }}>
                    <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
                    <button
                        className="btn btn-primary"
                        onClick={handleSave}
                        disabled={!selected}
                        style={{ minWidth: "120px" }}
                    >
                        Insert Link
                    </button>
                </div>
            </div>
            </div>
        </div>
    );
};

export default ContentLinkModal;